/**
 * Generic theme-related functionality.
 */



/**
 * Module imports.
 */
import { debounce } from 'lodash';



/**
 * Class for the theme itself.
 *
 * @class      Theme (name)
 */
export class Theming
{
	/**
	 * Adds the necessary event listeners for handling logo size.
	 */
	static logoSizeHandler()
	{
		// instantiate a new object to deal with the logo
		let LogoHandler = new Theming();

		// Wait for DOMContentLoaded
		$( document ).ready(
			() =>
			{
				// Get the initial size of the logo
				LogoHandler.getInitialSVGProportions();

				// Update the size of the logo
				LogoHandler.updateSVGLogoSize();
			}
		);

		// Listen for window resizing
		$( window ).resize(
			() =>
			{
				// Update the size of the logo
				LogoHandler.updateSVGLogoSize();
			}
		)
	}



	/**
	 * Handle window resizing.
	 */
	static resizeHandler()
	{
		// Wait for DOMContentLoaded
		$( document ).ready(
			() =>
			{
				const $htmlElem = $( 'html' );

				// Listen for window resize
				$( window ).on(
					'resize',
					debounce(
						() =>
						{
							$htmlElem.addClass( 'document--resizing' );
						},
						1000,
						{
							leading : true,
							trailing: false,
						}
					)
				);

				// Listen for window resize
				$( window ).on(
					'resize',
					debounce(
						() =>
						{
							$htmlElem.removeClass( 'document--resizing' );
						},
						1000,
						{
							leading : false,
							trailing: true,
						}
					)
				);
			}
		);
	}



	/**
	 * Class constructor.
	 */
	constructor()
	{
		this.initialLogoProportions =
		{
			header:
			{
				height     : 0,
				width      : 0,
				aspectRatio: false,
			},
			footer:
			{
				height     : 0,
				width      : 0,
				aspectRatio: false,
			},
		};
	}



	/**
	 * Sets size on SVG logo as IE11 does NOT like auto width and height for
	 * SVG apparently.
	 */
	getInitialSVGProportions()
	{
		// Set logo to a variable for easy reference
		let $headerWrapper = $( '.logo' );
		let $headerLogo    = $headerWrapper.find( 'svg' );
		let $footerWrapper = $( '.footer__logo' );
		let $footerLogo    = $footerWrapper.find( 'svg' );

		// Make sure it exists
		if ( 0 < $headerLogo.length )
		{
			// Set initial logo proportions
			this.initialLogoProportions.header.height = parseInt( $headerLogo.attr( 'height' ) );
			this.initialLogoProportions.header.width  = parseInt( $headerLogo.attr( 'width' ) );

			// Make sure we've got both width and height
			if ( 0 < this.initialLogoProportions.header.height && 0 < this.initialLogoProportions.header.width )
			{
				// Calculate aspect ratio
				this.initialLogoProportions.header.aspectRatio = ( this.initialLogoProportions.header.width / this.initialLogoProportions.header.height );
			}
		}

		// Make sure it exists
		if ( 0 < $footerLogo.length )
		{
			// Set initial logo proportions
			this.initialLogoProportions.footer.height = parseInt( $footerLogo.attr( 'height' ) );
			this.initialLogoProportions.footer.width  = parseInt( $footerLogo.attr( 'width' ) );

			// Make sure we've got both width and height
			if ( 0 < this.initialLogoProportions.footer.height && 0 < this.initialLogoProportions.footer.width )
			{
				// Calculate aspect ratio
				this.initialLogoProportions.footer.aspectRatio = ( this.initialLogoProportions.footer.width / this.initialLogoProportions.footer.height );
			}
		}
	}



	/**
	 * Sets size on SVG logo as IE11 does NOT like auto width and height for
	 * SVG apparently.
	 *
	 * NOTE: Currently this only matches logo against navbar height. In the
	 * future we may want to run a condition to determine if width is better.
	 */
	updateSVGLogoSize()
	{
		// Set logo to a variable for easy reference
		let $headerWrapper = $( '.logo' );
		let $headerLogo    = $headerWrapper.find( 'svg' );
		let $footerWrapper = $( '.footer__logo' );
		let $footerLogo    = $footerWrapper.find( 'svg' );

		// Make sure we know the aspect ratio to fit to
		if ( 0 < $headerLogo.length && false !== this.initialLogoProportions.header.aspectRatio )
		{
			$headerLogo.css( 'height', $headerWrapper.height() );
			$headerLogo.css( 'width',  ( $headerWrapper.height() * this.initialLogoProportions.header.aspectRatio ) );
		}

		// Make sure we know the aspect ratio to fit to
		if ( 0 < $footerLogo.length && false !== this.initialLogoProportions.footer.aspectRatio )
		{
			$footerLogo.css( 'height', $footerWrapper.height() );
			$footerLogo.css( 'width',  ( $footerWrapper.height() * this.initialLogoProportions.footer.aspectRatio ) );
		}
	}
}



// WEBPACK FOOTER //
// ../wp-content/themes/wisesite/assets/js/theming/theming.js